<template>
  <div class="bg-primary-500 h-screen w-screen h-dvh h-svh w-svw w-dvw p-0">
    <NavTop />
    <div class="relative z-10">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
